<template>
  <v-row no-gutters>
    <v-col cols="2" />
    <v-col cols="8" class="text-caption grey--text" :class="indent ? 'pl-4' : 'pl-1'">
      - {{ name }}
    </v-col>
    <v-col
      cols="2"
      class="pl-2 text-caption grey--text text-right"
      :class="{'h-price-paid': paid}"
    >
      {{ price | currency | hideZero }}
    </v-col>
  </v-row>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'

  export default {
    mixins: [
      Currenciable,
    ],

    props: {
      name: {
        required: true,
        type: String,
      },
      price: {
        required: true,
        type: [Number, String],
      },
      paid: {
        required: false,
        type: Boolean,
        default: false,
      },
      indent: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
